import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
function ConcealedAction({
  isVisible,
  ...props
}) {
  return /* @__PURE__ */ jsx(ConcealedActionStyled, {
    $isVisible: isVisible,
    ...props
  });
}
const ConcealedActionStyled = styled.div.withConfig({
  displayName: "ConcealedActionStyled",
  componentId: "sc-inr4c8-0"
})(["width:", ";opacity:", ";&:focus-within{width:auto;opacity:1;}"], (props) => props.$isVisible ? "auto" : "var(--list-item-concealead-action-width, 0)", (props) => props.$isVisible ? "1" : "var(--list-item-concealead-action-opacity, 0)");
export {
  ConcealedAction,
  ConcealedActionStyled
};
//# sourceMappingURL=ConcealedAction.js.map
